import React, { useEffect, useRef } from "react";
import { Form } from "../../../layout";
import { Divider, Grid, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DropLi, Model, UseForm } from "../../../hooks";
import { Button, Input, Select } from "../../../controls";
import { MaxLength } from "../../../hooks/Method";
import { CloseRounded } from "@mui/icons-material";

const AddSellPrice = ({ setShowForm, setProduct, setProdErrors }) => {
  const { t } = useTranslation();
  const { SellPriceMdl } = Model();
  const { PriceLabels } = DropLi();
  const priceRef = useRef();

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(SellPriceMdl);

  const handleFocus = () => {
    if (priceRef.current) {
      priceRef.current.select();
      priceRef.current.focus();
    }
  };

  useEffect(() => {
    handleFocus();
    setValues((j) => ({ ...j, title: PriceLabels[0].id }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateForm = () => {
    let temp = {};
    temp.title = values.title !== "" ? "" : t("titleIsReq");
    temp.price = values.price !== "" ? "" : t("sellPriceIsRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e, isAddAnother = false) => {
    !isAddAnother && e.preventDefault();
    if (validateForm()) {
      setProduct((j) => ({
        ...j,
        sellPrices: [...j.sellPrices, values],
      }));
      setProdErrors((j) => ({ ...j, sellPrices: "" }));
      if (isAddAnother) {
        resetFormControls();
      } else setShowForm(false);
    }
  };

  const handleClose = () => {
    resetFormControls();
    setShowForm(false);
  };

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Grid container spacing={2} className="bg-grayXS">
        <Grid item xs={12}>
          <div className="mb-10 d-flex j-between a-center pt-10 pl-10 pr-10">
            <div>
              <span className="tx-upp fs-20 fw-5 gray-color border-left">
                {t("addSellPrice")}
              </span>
            </div>

            <IconButton size="small" color="error" onClick={handleClose}>
              <CloseRounded />
            </IconButton>
          </div>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <div className="pl-15 pr-15">
            <Select
              label={t("title")}
              name="title"
              value={values.title}
              error={errors.title}
              onChange={handleInpChg}
              options={PriceLabels}
              required
              fullWidth
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="pl-15 pr-15">
            <Input
              label={t("price")}
              onInput={(e) => (e.target.value = MaxLength(e.target.value, 12))}
              name="price"
              value={values.price}
              error={errors.price}
              onChange={handleInpChg}
              fullWidth
              required
              inputRef={priceRef}
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="pl-15 pr-15 pb-15 tx-right d-flex g-10">
            <Button
              onClick={() => handleSubmit(true)}
              className="w-100pr"
              fullWidth
              size="small"
              variant="text"
            >
              {t("saveAndAddAnother")}
            </Button>
            <Button fullWidth size="small" type="submit">
              {t("saveAndExit")}
            </Button>
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddSellPrice;
